import useIntersectionObserver from "./useIntersectionObserver";
import ScrambleText from "./ScrambleText";

const experiences = [
  {
    id: 0,
    dateFrom: 'Oct 2025',
    dateTo: 'Present',
    badge: 'Full-time',
    title: 'Software Engineer I',
    company: 'Globaltek BPO Inc.',
    bullets: [
      'Built and deployed a serverless AWS automation platform using Playwright-core to automate onboarding/offboarding workflows across 8x8, ADP, and Azure AD — architected SQS queuing and DynamoDB job tracking for real-time polling, significantly reducing manual operational effort.',
      'Engineered a TypeScript CLI tool with idempotent batch-processing and API rate-limit handling to migrate 40,000+ Jira issues from Aha! to Jira across 20+ engineering teams with zero data loss in a single production cutover, cutting licensing costs ~60%.',
      'Designed and deployed a self-service AI knowledge platform using AWS Bedrock Knowledge Bases, S3 Vectors, and Strands — enabling RAG-powered knowledge base creation without engineering support and cutting article retrieval time by 60–75%.',
      'Developed 10 custom Atlassian Forge plugins and 13 automation workflows supporting 50+ Jira projects, centralizing administration intake and reducing processing time by ~30%.',
    ],
    tech: ['TypeScript', 'AWS Lambda', 'SQS', 'DynamoDB', 'AWS Bedrock', 'Playwright', 'Atlassian Forge', 'RAG / AI', 'Next.js'],
  },
  {
    id: 1,
    dateFrom: 'Apr 2025',
    dateTo: 'Aug 2025',
    badge: 'Intern · Tech Lead',
    title: 'Application Engineer Intern',
    company: 'Globaltek BPO Inc.',
    bullets: [
      'Led tech team for internal app development; performed code reviews and feature recommendations',
      'Built AWS Lambda functions with SST and developed API endpoints using Next.js',
      'Managed CRON jobs and AWS CloudWatch for automated web scraper monitoring',
      'Led v1 to v2 migration of company project (APIs and UI)',
      'Implemented CI/CD workflows with GitHub Actions and unit testing with Vitest',
    ],
    tech: ['Next.js', 'React', 'TypeScript', 'AWS Lambda', 'SST', 'AWS CloudWatch', 'GitHub Actions', 'Husky', 'Vitest'],
  },
  {
    id: 2,
    dateFrom: 'Dec 2024',
    dateTo: 'Mar 2025',
    badge: 'Internship',
    title: 'Software Engineer Intern',
    company: 'Hooli Software Inc.',
    bullets: [
      'Developed full UI components and pages using React, TypeScript, and Tailwind CSS',
      'Built and integrated API endpoints using Golang and gRPC',
      'Designed email templates for Go-based email services',
    ],
    tech: ['React', 'TypeScript', 'Tailwind CSS', 'Golang', 'gRPC', 'Next.js', 'HTML/CSS'],
  },
];

const Experience = () => {
  const [ref, isInView] = useIntersectionObserver();

  return (
    <div ref={ref} className={`section-wrap ${isInView ? 'show' : 'hidden'}`} id="experience">
      <div className="section-head">
        <div className="section-eye">Where I've worked</div>
        <ScrambleText text="Experience" className="section-title" />
        <div className="section-rule" />
      </div>

      <div className="exp-list">
        {experiences.map((exp) => (
          <div key={exp.id} className="exp-item">
            <div className="exp-meta">
              <div className="exp-date">{exp.dateFrom}<br />— {exp.dateTo}</div>
              <span className="exp-type-badge">{exp.badge}</span>
            </div>
            <div className="exp-body">
              <div className="exp-role">{exp.title}</div>
              <div className="exp-company">{exp.company}</div>
              <ul className="exp-bullets">
                {exp.bullets.map((b, i) => <li key={i}>{b}</li>)}
              </ul>
              <div className="chip-row">
                {exp.tech.map((t) => <span key={t} className="chip">{t}</span>)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
